import * as React from "react"
import { connect } from "react-redux"
import { Drawer, Switch } from "antd"
import { toggleOnBackgroundOffline } from "../../redux/actionCreators/developer"
import _ from "../../utils/lodashUtils"
import "./developerTools.styles.scss"

const mapStateToProps = (state) => ({
  developerTools: _.get(state, "developer", {}),
})

export const DeveloperTools = connect(mapStateToProps, {
  toggleOnBackgroundOffline,
})(
  React.memo((props) => {
    const {
      visible,
      closeDeveloperTools,
      developerTools,
      toggleOnBackgroundOffline,
    } = props

    const isOfflineOnAppInBackground_enabled = _.get(
      developerTools,
      "offlineOnBackground",
      true
    )

    return (
      <section className="tools-container">
        <Drawer
          visible={visible}
          closable
          onClose={closeDeveloperTools}
          title="🛠 Developer Tools"
        >
          <section className="tool-container">
            <label className="tool-label">
              Toggle offline on background.
              <p className="description">
                By default, as the app goes in background or loses focus, the
                user is marked offline and nudge alert is shown to the partner.
              </p>
              <Switch
                defaultChecked={isOfflineOnAppInBackground_enabled}
                onChange={toggleOnBackgroundOffline}
              />
            </label>
          </section>
        </Drawer>
      </section>
    )
  })
)
